import Home from '../components/pages/Home/Home';
import { LoginStatus } from '../types/models/status/status.types';
import { UserRoles } from '../types/models/user/user.types';
import LaunchingRegister from '../components/pages/authentication/RegisterScreen/LaunchingRegister';
import NewRegisterSteps from '../components/pages/authentication/RegisterSteps/NewRegisterSteps';
import NewCreateConsultationSteps from '../components/pages/connected/CreateConsultation/NewCreateConsultationSteps';
import DashboardHome from '../components/pages/connected/Dashboard/DashboardHome/DashboardHome';
import DashboardCommerciaux from '../components/pages/connected/Dashboard/DashboardCommerciaux/DashboardCommerciaux';
// import DashboardProspects from "../components/pages/connected/Dashboard/DashboardProspects/DashboardProspects";
import DashboardConsultation from '../components/pages/connected/Dashboard/DashboardConsultation/DashboardConsultation';
import DashboardHistoryENT from '../components/pages/connected/Dashboard/DashboardHistoryENT/DashboardHistoryENT';
// import DashboardInvoices from "../components/pages/connected/Dashboard/DashboardInvoices/DashboardInvoices";
import InitPassword from '../components/pages/authentication/InitPassword/InitPassword';
import LoginCommercial from '../components/pages/authentication/LoginCommercial/LoginCommercial';
import LoginENT from '../components/pages/authentication/LoginENT/LoginENT';
import LoginPUB from '../components/pages/authentication/LoginPUB/LoginPUB';
import DashboardHistoryPUB from '../components/pages/connected/Dashboard/DashboardHistoryPUB/DashboardHistoryPUB';
import ForgotPassword from '../components/pages/authentication/ForgotPassword/ForgotPassword';
import DashboardENT from '../components/pages/connected/Dashboard/DashboardENT/DashboardENT';
import DashboardHistoryPUBSummary from '../components/pages/connected/Dashboard/DashboardHistoryPUB/DashboardHistoryPUBSummary/DashboardHistoryPUBSummary';
import DashboardReceiptsENT from '../components/pages/connected/Dashboard/DashboardReceiptsENT/DashboardReceiptsENT';
import LoginDIR from '../components/pages/authentication/LoginDIR/LoginDIR';
import DashboardCOM from '../components/pages/connected/Dashboard/DashboardCOM/DashboardCOM';
import DashboardHistoryENTSummary from '../components/pages/connected/Dashboard/DashboardHistoryENTSummary/DashboardHistoryENTSummary';
import ProfileAccount from '../components/pages/connected/Profile/ProfileAccount/ProfileAccount';
// import ProfileCredentials from "../components/pages/connected/Profile/ProfileCredentials/ProfileCredentials";
import ProfileCompany from '../components/pages/connected/Profile/ProfileCompany/ProfileCompany';
import DashboardHistoryPUBDevis from '../components/pages/connected/Dashboard/DashboardHistoryPUB/DashboardHistoryPUBDevis/DashboardHistoryPUBDevis';
import RedirectToProfile from './redirects/RedirectToProfile';
import DashboardPUBTemp from '../components/pages/connected/Dashboard/DashboardPUBTemp/DashboardPUBTemp';
import DashboardHistoryPUBQuestions from '../components/pages/connected/Dashboard/DashboardHistoryPUB/DashboardHistoryPUBQuestions/DashboardHistoryPUBQuestions';
import DashboardHistoryENTQuestions from '../components/pages/connected/Dashboard/DashboardHistoryENT/DashboardHistoryENTQuestions/DashboardHistoryENTQuestions';
import DashboardStatsCOM from '../components/pages/connected/Dashboard/DashboardStatsCOM/DashboardStatsCOM';
import DashboardStatsDIR from '../components/pages/connected/Dashboard/DashboardStatsDIR/DashboardStatsDIR';
import DashboardDIR from '../components/pages/connected/Dashboard/DashboardDIR/DashboardDIR';
import RGPD from '../components/pages/commons/RGPD/RGPD';
import CGV from '../components/pages/commons/CGV/CGV';
import MentionsLegales from '../components/pages/commons/MentionsLegales/MentionsLegales';
import Referencement from '../components/pages/commons/Referencement/Referencement';
import ProfileEntity from '../components/pages/connected/Profile/ProfileEntity/ProfileEntity';
import Contact from '../components/pages/commons/Contact/Contact';
import ProfilePassword from '../components/pages/connected/Profile/ProfilePassword/ProfilePassword';
import DashboardInProgressConsultsENT from '../components/pages/connected/Dashboard/DashboardIPConsultsENT/DashboardIPConsultsENT';
import DashboardClosedConsultsENT from '../components/pages/connected/Dashboard/DashboardClosedConsultsENT/DashboardClosedConsultsENT';
import DashboardInProgressConsultsCOM from '../components/pages/connected/Dashboard/DashboardIPConsultsCOM/DashboardIPConsultsCOM';
import DashboardSubscriptions from '../components/pages/connected/Dashboard/DashboardSubscriptions/DashboardSubscriptions';
import DashboardCompanies from '../components/pages/connected/Dashboard/DashboardCompanies/DashboardCompanies';
import DashboardReceiptsPUB from '../components/pages/connected/Dashboard/DashboardReceiptsPUB/DashboardReceiptsPUB';
import DashboardCommissionsInvoices from '../components/pages/connected/Dashboard/DashboardCommissionsInvoices/DashboardCommissionsInvoices';
import DashboardCommissionDetails from '../components/pages/connected/Dashboard/DashboardCommissionsInvoices/DashboardCommissionDetails/DashboardCommissionDetails';
import DashboardProspectsCOM from '../components/pages/connected/Dashboard/DashboardProspectsCOM/DashboardProspectsCOM';
import DashboardProspections from '../components/pages/connected/Dashboard/DashboardProspections/DashboardProspections';
import DashboardProspectsDIR from '../components/pages/connected/Dashboard/DashboardProspectsDIR/DashboardProspectsDIR';
import DashboardResults from '../components/pages/connected/Dashboard/DashboardResults/DashboardResults';
import DashboardHistoryCOMSummary from '../components/pages/connected/Dashboard/DashboardHistoryCOMSummary/DashboardHistoryCOMSummary';
import ProfileSubUsersENT from '../components/pages/connected/Profile/ProfileSubUsersENT/ProfileSubUsersENT';
import SearchCompaniesOnMap from '../components/pages/connected/Dashboard/SearchCompaniesOnMap/SearchCompaniesOnMap';

const IS_ACTUAL_PUB_DASHBOARD_ENABLED = true;

export const routesList = Object.freeze({
  [LoginStatus.Logged]: {
    [UserRoles.AcheteurPublic]: !IS_ACTUAL_PUB_DASHBOARD_ENABLED
      ? [
          {
            component: Home,
            path: '',
            title: 'PubliConsult',
          },
          {
            component: NewRegisterSteps,
            path: 'step_wizard/:role',
            title: 'Inscription',
          },
          {
            component: DashboardPUBTemp,
            path: 'dashboard',
            title: 'Inscription confirmée',
          },

          // Old screens
          // {
          //   component: CreateConsultationSteps,
          //   path: 'dashboard/consultation/create/step/:step'
          // }
          // {
          //   component: RegisterSteps,
          //   path: 'register/:role/step/:step',
          //   title: ''
          // },
        ]
      : [
          {
            component: Home,
            path: '',
            title: 'PubliConsult',
          },
          {
            component: NewRegisterSteps,
            path: 'step_wizard/:role',
            title: 'Inscription',
          },
          {
            component: DashboardHome,
            path: 'dashboard',
            title: 'Tableau de bord',
          },
          {
            component: DashboardConsultation,
            path: 'dashboard/consultations',
            title: 'Consultations en cours',
          },
          {
            component: DashboardHistoryPUB,
            path: 'dashboard/historique',
            title: 'Historique de mes consultations',
          },
          {
            component: DashboardHistoryPUBSummary,
            path: 'dashboard/consultations/:consultationId',
            title: 'Détails de la consultation',
          },
          {
            component: DashboardHistoryPUBDevis,
            path: 'dashboard/consultations/:consultationId/devis',
            title: 'Devis pour la consultation',
          },
          {
            component: DashboardHistoryPUBQuestions,
            path: 'dashboard/consultations/:consultationId/questions',
            title: 'Questions pour la consultation',
          },
          {
            component: NewCreateConsultationSteps,
            path: 'dashboard/nouvelle_consultation',
            title: 'Nouvelle consultation',
          },
          {
            component: NewCreateConsultationSteps,
            path: 'dashboard/nouvelle_consultation/:consultationId',
            title: 'Nouvelle consultation',
          },
          {
            component: SearchCompaniesOnMap,
            path: 'dashboard/map',
            title: 'Carte des entreprises',
          },
          {
            component: DashboardCompanies,
            path: 'dashboard/companies',
            title: 'Annuaire des entreprises',
          },
          {
            component: DashboardReceiptsPUB,
            path: 'dashboard/receipts',
            title: 'Mes factures',
          },
          {
            component: RedirectToProfile,
            path: 'dashboard/profile',
            title: 'Profil',
          },
          {
            component: ProfileAccount,
            path: 'profile',
            title: 'Mes Informations',
          },
          // {
          //   component: ProfileCredentials,
          //   path: 'profile/credentials',
          //   title: 'Mes Identifiants'
          // },
          {
            component: ProfilePassword,
            path: 'profile/password',
            title: 'Modifier mon mot de passe',
          },
          {
            component: ProfileEntity,
            path: 'profile/entity',
            title: 'Mon Entité',
          },
          // {
          //   component: ProfileCompany,
          //   path: 'profile/company',
          //   title: 'Mon Entreprise'
          // },
        ],
    [UserRoles.Entreprise]: [
      {
        component: DashboardENT,
        path: 'dashboard',
        title: 'Tableau de bord',
      },
      {
        component: Home,
        path: '',
        title: 'PubliConsult',
      },
      {
        component: DashboardHistoryENT,
        path: 'dashboard/historique',
        title: 'Historique des consultations',
      },
      {
        component: DashboardHistoryENTSummary,
        path: 'dashboard/historique/:consultationId',
        title: 'Détails de la consultation',
      },
      {
        component: DashboardHistoryENTQuestions,
        path: 'dashboard/historique/:consultationId/questions',
        title: 'Questions pour la consultation',
      },
      {
        component: DashboardInProgressConsultsENT,
        path: 'dashboard/consultations_in_progress',
        title: 'Consultations en cours',
      },
      {
        component: DashboardClosedConsultsENT,
        path: 'dashboard/consultations_closed',
        title: 'Consultations terminées',
      },
      {
        component: DashboardReceiptsENT,
        path: 'dashboard/receipts',
        title: 'Mes factures',
      },
      {
        component: DashboardSubscriptions,
        path: 'dashboard/subscriptions',
        title: 'Mes Souscriptions',
      },
      {
        component: RedirectToProfile,
        path: 'dashboard/profile',
        title: 'Mes factures',
      },
      {
        component: ProfileAccount,
        path: 'profile',
        title: 'Mes Informations',
      },
      // {
      //   component: ProfileCredentials,
      //   path: 'profile/credentials',
      //   title: 'Mes Identifiants'
      // },
      {
        component: ProfilePassword,
        path: 'profile/password',
        title: 'Modifier mon mot de passe',
      },
      {
        component: ProfileCompany,
        path: 'profile/company',
        title: 'Mon Entreprise',
      },
      {
        component: ProfileSubUsersENT,
        path: 'profile/subusers',
        title: 'Sous-utilisateurs',
      },
      {
        component: NewRegisterSteps,
        path: 'step_wizard/:role',
        title: 'Inscription',
      },
    ],
    [UserRoles.Commercial]: [
      {
        component: Home,
        path: '',
        title: 'PubliConsult',
      },
      {
        component: DashboardCOM,
        path: 'dashboard',
        title: 'Tableau de bord',
      },
      {
        component: DashboardProspectsCOM,
        path: 'dashboard/prospects',
        title: 'Mes prospects',
      },
      {
        component: DashboardProspections,
        path: 'dashboard/prospection',
        title: 'Mes prospects',
      },
      {
        component: DashboardInProgressConsultsCOM,
        path: 'dashboard/consultations_in_progress',
        title: 'Consultations en cours',
      },
      {
        component: DashboardHistoryCOMSummary,
        path: 'dashboard/consultations_in_progress/:consultationId',
        title: 'Détails de la consultation',
      },
      {
        component: DashboardCommissionsInvoices,
        path: 'dashboard/facturation',
        title: 'Mes factures',
      },
      {
        component: DashboardCommissionDetails,
        path: 'dashboard/facturation/:month/:year',
        title: 'Mes factures',
      },
      {
        component: DashboardStatsCOM,
        path: 'dashboard/stats',
        title: 'Statistiques',
      },
      {
        component: RedirectToProfile,
        path: 'dashboard/profile',
        title: 'Mes factures',
      },
      {
        component: ProfileAccount,
        path: 'profile',
        title: 'Mes Informations',
      },
      // {
      //   component: ProfileCredentials,
      //   path: 'profile/credentials',
      //   title: 'Mes Identifiants'
      // },
      {
        component: ProfilePassword,
        path: 'profile/password',
        title: 'Modifier mon mot de passe',
      },
      // {
      //   component: ProfileCompany,
      //   path: 'profile/company',
      //   title: 'Mon Entreprise'
      // },
    ],
    [UserRoles.DirecteurCommercial]: [
      {
        component: Home,
        path: '',
        title: 'PubliConsult',
      },
      {
        component: DashboardDIR,
        path: 'dashboard',
        title: 'Tableau de bord',
      },
      {
        component: DashboardCommerciaux,
        path: 'dashboard/commerciaux',
        title: 'Commerciaux',
      },
      {
        component: DashboardProspectsDIR,
        path: 'dashboard/prospects',
        title: 'Mes prospects',
      },
      {
        component: DashboardResults,
        path: 'dashboard/results',
        title: 'Résultats',
      },
      {
        component: DashboardStatsDIR,
        path: 'dashboard/stats',
        title: 'Statistiques',
      },
    ],
  },
  [LoginStatus.NotFinalized]: [
    {
      component: NewRegisterSteps,
      path: 'step_wizard/:role',
      title: 'Inscription',
    },
  ],
  [LoginStatus.NotLogged]: [
    {
      component: Home,
      path: '',
      title: 'PubliConsult',
    },
    {
      component: LoginCommercial,
      path: 'login/commercial',
      title: 'Connexion Commercial',
    },
    {
      component: LoginDIR,
      path: 'login/directeur',
      title: 'Connexion Directeur Commercial',
    },
    {
      component: LoginENT,
      path: 'login/entreprise',
      title: 'Connexion Entreprise',
    },
    {
      component: LoginPUB,
      path: 'login/acheteurs',
      title: 'Connexion Acheteur Public',
    },
    {
      component: NewRegisterSteps,
      path: 'step_wizard/:role',
      title: 'Inscription',
    },
    {
      component: LaunchingRegister,
      path: 'register/:variant',
      title: 'Inscription',
    },
    {
      component: InitPassword,
      path: 'password/init/:commercialId',
      title: 'Initialisation du mot de passe',
    },
    {
      component: InitPassword,
      path: 'password/init/:commercialId/:hash',
      title: 'Initialisation du mot de passe',
    },
    {
      component: ForgotPassword,
      path: 'password/forgot/:role',
      title: 'Mot de passe oublié',
    },
    {
      component: ForgotPassword,
      path: 'password/forgot/:role/:hash',
      title: 'Mot de passe oublié',
    },

    // Old screens
    // {
    //   component: LoginScreen,
    //   path: 'login',
    //   title: 'Connexion'
    // },
    // {
    //   component: RegisterSteps,
    //   path: 'register/:role/step/:step'
    // },
  ],
});

export const commonRoutesList = [
  {
    component: RGPD,
    path: 'RGPD',
    title: 'RGPD',
  },
  {
    component: CGV,
    path: 'CGV',
    title: 'Conditions générales de vente',
  },
  {
    component: MentionsLegales,
    path: 'mentions_legales',
    title: 'Mentions légales',
  },
  {
    component: Referencement,
    path: 'referencement',
    title: 'Politique des référencement',
  },
  {
    component: Contact,
    path: 'contact',
    title: 'Nous contacter',
  },
];
